import { render, staticRenderFns } from "./NewShopList.vue?vue&type=template&id=52186d08&scoped=true&"
import script from "./NewShopList.vue?vue&type=script&lang=js&"
export * from "./NewShopList.vue?vue&type=script&lang=js&"
import style0 from "./NewShopList.vue?vue&type=style&index=0&id=52186d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52186d08",
  null
  
)

export default component.exports